import styled from '@emotion/styled';
import { gutterSizes, colors, fontSizes } from '@gumtree/ui-library/src/base/theme';

export const DisclaimerContainer = styled.div`
    color: ${colors.bark};
    line-height: 1.4;

    hr {
        border: 0;
        height: 1px;
        background: ${colors.bark20};
        margin: 0;
    }
`;

export const Title = styled.h4`
    margin-bottom: ${gutterSizes.medium};
    padding-top: ${gutterSizes.medium};
`;

export const Content = styled.p`
    font-size: ${fontSizes.smaller};
    letter-spacing: 0.3px;
`;
